import { keyframes } from "@mui/material/styles";

export const zoomInAndOutAnimation = keyframes`
  from {
    transform: scale(0);
  }
  60% {
    transform: scale(1.2);
  }
  to {
    transform: scale(1);
  }
`;

export const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const fadeOutAnimation = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
